import React from 'react'
import { Helmet } from 'react-helmet'
import { Result, Button } from 'antd'
import 'antd/lib/result/style'
import { useHistory, useLocation } from 'react-router-dom'

const AuthenticationError = () => {
  const history = useHistory()
  const location = useLocation()
  
  // Extract error code and description from query parameters
  const searchParams = new URLSearchParams(location.search)
  const errorCode = searchParams.get('error') || 'unknown_error'
  const errorDescription = searchParams.get('error_description') || 'An unexpected error occurred during authentication'

  return (
    <>
      <Helmet title="Authentication Error" />
      <Result
        status="error"
        title="Authentication Failed"
        subTitle={errorDescription}
        extra={[
          <Button key="login" type="primary" onClick={() => history.push('/authentication/login')}>
            Try Login Again
          </Button>,
        ]}
      />
    </>
  )
}

export default {
  name: 'AuthenticationError',
  routeProps: {
    path: '/authentication/error',
    component: AuthenticationError,
  },
}
